export default __webpack_public_path__ + "static/media/login2.e765418f.png";